import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { HttpClientService } from '../services/http-client.service';

@Injectable({
  providedIn: 'root'
})
export class RegistroService {

  private readonly apiUrl = `${environment.api}/solicitacoes`;

  constructor(
    private _http: HttpClient,
    private http: HttpClientService
) {}

  orgaoRegistroPesquisa(protocolo: any): Promise<any> {
    const url: string = this.apiUrl + `/${protocolo}`;
    return this.http.get(url)
      .toPromise()
      .then(response => response);
  }
}
